import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import BusinessInvoicesComponent from '../../components/business-component/business-profile/BusinessInvoices'
import BusinessPlansComponent from '../../components/business-component/business-profile/BusinessPlans'
import BusinessProfileComponent from '../../components/business-component/business-profile/BusinessProfile'

function BusinessProfile() {
  const navigate = useNavigate()
  const { tab } = useParams()

  const [activeTab, setActiveTab] = useState(tab || 'my-profile')

  useEffect(() => {
    // Update activeTab when route param changes
    if (tab && tab !== activeTab) {
      setActiveTab(tab)
    }
  }, [tab, activeTab])

  const PROFILE_TABS = [
    { key: 'my-profile', label: 'Personal Info' },
    { key: 'plans', label: 'My Plans' },
    { key: 'invoice', label: 'Invoices' },
  ]

  const handleTabChange = (key) => {
    setActiveTab(key)
    navigate(`/business/profile/${key}`)
  }

  const renderActivePanel = () => {
    switch (activeTab) {
      case 'my-profile':
        return <BusinessProfileComponent />
      case 'plans':
        return <BusinessPlansComponent />
      case 'invoice':
      default:
        return <BusinessInvoicesComponent />
    }
  }

  return (
    <div className="flex h-full flex-col lg:flex-row">
      {/* Tablet & Mobile: top tabs */}
      <div className="lg:hidden bg-gray-100 p-2 border-b">
        <nav className="flex space-x-2 overflow-x-auto">
          {PROFILE_TABS.map(({ key, label }) => (
            <button
              key={key}
              onClick={() => handleTabChange(key)}
              className={`flex-shrink-0 px-3 py-2 rounded transition-colors cursor-pointer text-sm
                ${activeTab === key ? 'bg-heading-primary text-white' : 'hover:bg-gray-200'}`}
            >
              {label}
            </button>
          ))}
        </nav>
      </div>

      <div className="flex flex-1">
        {/* Sidebar (visible on desktop ≥1024px) */}
        <aside className="hidden lg:block w-48 bg-gray-100 p-4 border-r">
          <nav className="space-y-2">
            {PROFILE_TABS.map(({ key, label }) => (
              <button
                key={key}
                onClick={() => handleTabChange(key)}
                className={`block w-full text-left px-3 py-2 rounded transition-colors cursor-pointer
                  ${activeTab === key ? 'bg-heading-primary text-white' : 'hover:bg-gray-200'}`}
              >
                {label}
              </button>
            ))}
          </nav>
        </aside>

        {/* Content area */}
        <main className="flex-1 p-4 lg:p-6 overflow-auto">{renderActivePanel()}</main>
      </div>
    </div>
  )
}

export default BusinessProfile
